import styled, { css } from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'
import { isDesktop } from 'utils/device'

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 100vh;
    overflow: hidden;
    direction: ltr;
`

export const ArtefactContainer = styled.div`
    width: 100%;
    height: 100%;
    ${FlexCentered}
    @media only screen and (orientation: portrait) {
        ${({ isArtefactMode, isQuizMode }) =>
            isArtefactMode && !isQuizMode && !isDesktop
                ? css`
                      height: 70%;
                  `
                : css`
                      height: 100%;
                  `}
    }

    @media only screen and (orientation: landscape) {
        width: 95%;
    }
`
